import { render, staticRenderFns } from "./feedbackDialog.vue?vue&type=template&id=31d8c54e"
import script from "./feedbackDialog.vue?vue&type=script&lang=js"
export * from "./feedbackDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports